// Unsaved encoding work (scores, comments, attendance marks) is kept in the browser as it's typed,
// so a power cut, crash or accidental reload doesn't lose it. A draft is removed once its data is
// saved to the server. Keys include the signed-in user's id, so two people sharing a computer never
// see each other's drafts.
const PREFIX = 'pawigrade:draft:';

// Drafts nobody came back to are dropped after this long.
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

export const draftKey = (userId, ...parts) => `${PREFIX}${userId ?? 'anon'}:${parts.join(':')}`;

// Returns { data, savedAt } or null.
export function readDraft(key) {
  try {
    const draft = JSON.parse(localStorage.getItem(key) ?? 'null');
    if (!draft || typeof draft.savedAt !== 'number') return null;
    if (Date.now() - draft.savedAt > MAX_AGE_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return draft;
  } catch {
    return null;
  }
}

export function writeDraft(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify({ data, savedAt: Date.now() }));
  } catch {
    // Storage can be blocked or full; encoding still works, just without the backup.
  }
}

export function clearDraft(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // Nothing to clear.
  }
}

// Removes every expired draft, so abandoned ones don't pile up.
export function purgeExpiredDrafts() {
  try {
    for (let i = localStorage.length - 1; i >= 0; i -= 1) {
      const key = localStorage.key(i);
      if (key?.startsWith(PREFIX)) readDraft(key);
    }
  } catch {
    // Storage unavailable.
  }
}

export const formatDraftTime = (savedAt) =>
  new Date(savedAt).toLocaleString('en-PH', { dateStyle: 'medium', timeStyle: 'short' });
